<template>
  <!-- Content -->
  <div class="container-xxl flex-grow-1 container-p-y">
    <h4 class="fw-bold py-3 mb-4">
        <span class="text-muted fw-light">Invoice Code Registration /</span> Add New
    </h4>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <h5 class="card-header">Register New Invoice Code</h5>
          <div class="row">
            <div class="col-md-6">
              <div class="card-body">
                <form id="formAccountSettingsApiKey" method="POST" onsubmit="return false" class="fv-plugins-bootstrap5 fv-plugins-framework" novalidate="novalidate">
                  <div class="row fv-plugins-icon-container">
                    <div class="mb-3 col-12">
                      <label for="apiAccess" class="form-label">Prefix Name</label>
                      <div class="position-relative">
                        <VueMultiselect 
                          v-model="prefixSelected" 
                          :options="PREFIXS_OPTIONS" 
                          placeholder="Please choose prefix" 
                          label="name" 
                          :close-on-select="true"
                          :clear-on-select="false"
                        />
                        <div class="error-msg" v-if="v$.stateData.prefix.$error"> 
                          {{ v$.stateData.prefix.$errors[0].$message }}
                        </div>
                      </div>
                    </div>
                    <div class="mb-3 col-12">
                      <label for="apiAccess" class="form-label">Export Country</label>
                      <div class="position-relative">
                        <VueMultiselect 
                          v-model="vcjSelected" 
                          :options="COUNTRIES_OPTIONS" 
                          placeholder="Please choose country" 
                          label="name" 
                          :close-on-select="true"
                          :clear-on-select="false"
                        />
                        <div class="error-msg" v-if="v$.stateData.vcj.$error"> 
                          {{ v$.stateData.vcj.$errors[0].$message }}
                        </div>
                      </div>
                    </div>
                    <div class="mb-3 col-6">
                      <label for="apiAccess" class="form-label">Register Date</label>
                      <div class="position-relative">
                        <flat-pickr 
                          v-model="stateData.date" 
                          :config="calendarConfig" 
                          placeholder="Select a date" 
                          id="register_date"
                          name="register-date" 
                          class="form-control"
                          @change="onchange()"  
                        >
                        </flat-pickr>
                        <div class="error-msg" v-if="v$.stateData.date.$error"> 
                          {{ v$.stateData.date.$errors[0].$message }}
                        </div>
                      </div>
                    </div>
                    <div class="mb-3 col-6">
                      <label for="apiAccess" class="form-label">Consective No</label>
                      <div class="position-relative">
                        <input class="form-control text-end" 
                          type="text" 
                          name="consective-no" 
                          id="consective_no" 
                          v-model="stateData.consective_no"
                          v-on:keyup=onchange()
                        >
                        <div class="error-msg" v-if="v$.stateData.consective_no.$error"> 
                          {{ v$.stateData.consective_no.$errors[0].$message }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 mt-4">
                      <button type="submit" @click="generateCode" class="btn btn-outline-success me-2 d-grid w-100">
                        Generate Invoice Code
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="col-md-6 pe-5 d-none1">
              <div class="bg-lighter rounded p-4 mb-3 position-relative">
                <div class="d-flex align-items-center flex-wrap mt-4">
                  <h5 class="mb-0 me-3">Generated Invoice Code</h5> 
                </div>
                <div class="alert alert-success d-flex mt-4" role="alert">
                  <div class="d-flex flex-column ps-1">
                    <h6 class="alert-heading d-flex align-items-center fw-bold mb-3 mt-3">{{stateData.invoice_code}}</h6>
                  </div>
                </div>
                <div class="mt-3 p-1">
                  <div class="error-msg" v-if="v$.stateData.invoice_code.$error"> 
                    {{ v$.stateData.invoice_code.$errors[0].$message }}
                  </div>
                </div>
                <div class="row" style="margin-top:4rem">
                  <form id="" @submit.prevent="handleSave">
                    <div class="col col-sm-12 text-center">
                      <button type="submit" class="btn btn-primary me-2">Save Code</button>
                      <router-link to="/invoice-registration" data-i18n="Invoice Registration" class="btn btn-outline-secondary w-45">
                        <i class='bx bx-arrow-back' ></i>
                        Back To Definition
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- / Content -->
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import { configs } from '@/config/calendar.js';
import useValidate from '@vuelidate/core'
import { required, numeric, maxLength, helpers } from '@vuelidate/validators'
import { mapState } from "vuex";
import { COUNTRIES, PREFIXS } from "../../config/common"
import VueMultiselect from 'vue-multiselect'
import moment from 'moment'


export default {
  name: 'InvoiceRegistrationAdd',
  components: {
    flatPickr,
    VueMultiselect
  },
  data() {
    return {
      v$: useValidate(),
      calendarConfig: configs,
      prefixSelected: null,
      vcjSelected: null
    }
  },
  computed: {
    ...mapState({
      stateData: state => state.invoiceRegistrationAdd.stateData
    }),
    COUNTRIES_OPTIONS() {
      return COUNTRIES;
    },
    PREFIXS_OPTIONS() {
      return PREFIXS;
    },
  },
  watch: {
    "prefixSelected" (newVal) {
      this.stateData.prefix = newVal.value ? newVal.value : "";
      this.onchange();
    },
    "vcjSelected" (newVal) {
      this.stateData.vcj = newVal.value ? newVal.value : "";
      this.onchange();
    }
  },
  beforeCreate() {
    this.$store.dispatch('invoiceRegistrationAdd/resetState');
  },
  created() {
    let today = new Date();
    this.stateData.date = this.$moment(today).format("YYYY-MM-DD");
    let selected = this.PREFIXS_OPTIONS.filter(item => {
      return item.value == "LMD";
    });
    this.prefixSelected = selected[0];
    
    this.$store.dispatch('invoiceRegistrationAdd/getLatestCode').then(
      () => { 
        console.log("Get Latest Code Successfully !!!");
      },
      (error) => {
        console.log(error);
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Can not get the latest Consective code value !'
        });
      }
    );
  },
  methods: {
    handleSave() {
      this.v$.$validate();
      if (!this.v$.$error) {
        this.$store.dispatch('invoiceRegistrationAdd/saveCode', this.stateData).then(
          () => {
            let self = this;
            this.$swal.fire(
              'Saved',
              'Partner Code is saved sucessfully !',
              'success'
            ).then(function() {
              self.$router.push('/invoice-registration');
            });
          },
          error => {
            console.log(error);
            // Get error message from backend
            const backendMessage =
              error?.response?.data?.detail || 'Failed to save Invoice Code!';

            this.$swal.fire({
              icon: 'error',
              title: 'Error',
              text: backendMessage
            });
          }
        );
      }
    },
    generateCode() {
      let selected_date = moment(this.stateData.date).format("YYMMDD");
      this.stateData.invoice_code = this.stateData.prefix + this.stateData.vcj  + 
        selected_date +"-" + this.stateData.consective_no;
    },
    onchange() {
      this.stateData.invoice_code = "";
    }
  },
  validations() {
    return {
      stateData: {
        prefix: {
          required: helpers.withMessage('This field cannot be empty', required)
        },
        vcj: {
          required: helpers.withMessage('This field cannot be empty', required)
        },
        date: {
          required: helpers.withMessage('Register Date cannot be empty', required)
        },
        consective_no: { 
          required: helpers.withMessage('Consective No cannot be empty', required),
          numeric: helpers.withMessage('Please input number only', numeric),
          maxLength: helpers.withMessage('Please input maximum 3 letters', maxLength(3)),
        },
        invoice_code: {
          required: helpers.withMessage('Please generate new partner code', required)
        }
      }
    }
  }
}
</script>